export enum CarInformationField {
  CarUser = 'carUser',
  FuelType = 'fuelType',
  CarType = 'carType',
  ModelYear = 'modelYear',
  LeasingCostPerMonth = 'leasingCostPerMonth',
  FuelPriceSekPerUnit = 'fuelPriceSekPerUnit',
  FuelConsumptionUnitPerKm = 'fuelConsumptionUnitPerKm',
  DrivingDistancePerYearKm = 'drivingDistancePerYearKm',
  NewCarPriceSek = 'newCarPriceSek',
  EstimatedCarValueDeprication = 'estimatedCarValueDeprication',
  CarLoanPerMonth = 'carLoanPerMonth',
  VehicleTaxPerYear = 'vehicleTaxPerYear',
  InsuranceCostPerYear = 'insuranceCostPerYear',
  ServiceAndRepairCostPerYear = 'serviceAndRepairCostPerYear',
  EmissionsCo2PerKm = 'emissionsCo2PerKm',
  VariableDepreciationPercentage = 'variableDepreciationPercentage',
}
